var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07996 19.55H23.04V17.98H0.959961V19.55H7.06996H7.07996Z",
    fill: "#AD6643"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.959961 4.44995H23.03V17.97H0.959961V4.44995Z",
    fill: "#E9EEF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.59961 17.9699H5.10961V16.9499C5.10961 16.7999 5.03961 16.6699 4.95961 16.6699H2.74961C2.66961 16.6699 2.59961 16.7999 2.59961 16.9499V17.9699Z",
    fill: "#95573A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.32035 19.11V18.41H22.6804V19.11H1.32035ZM4.76035 17.54H2.96035V17.11H4.76035V17.54ZM22.6804 4.89001H1.32035V17.53H2.25035V16.95C2.25035 16.55 2.47035 16.23 2.76035 16.23H4.97035C5.25035 16.23 5.48035 16.54 5.48035 16.95V17.53H22.6904V4.89001H22.6804ZM11.1104 4.02001H0.960352C0.760352 4.02001 0.610352 4.22001 0.610352 4.46001V19.55C0.610352 19.79 0.770352 19.99 0.960352 19.99H16.7004H16.9204H18.7304H23.0304C23.2304 19.99 23.3804 19.79 23.3804 19.55V4.45001C23.3804 4.21001 23.2204 4.01001 23.0304 4.01001H11.1004L11.1104 4.02001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteboard);
export default __webpack_public_path__ + "static/media/whiteboard.4fffc4b3815a80cf7d329388ccbeb515.svg";
export { ForwardRef as ReactComponent };